import React from "react";
import styled from "@emotion/styled";

import { ContactUsButton } from "./AboutUs";
import { useTheme } from "../../contexts/themeContext";

const reducer = (state, action) => {
  switch (action.type) {
    case "EMAIL":
      return { ...state, email: action.payload };
    case "MESSAGE":
      return { ...state, message: action.payload };
    default:
      throw Error("Invalid action");
  }
};

const defaultState = {
  message: "",
  email: ""
};

const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
};

function Form(props) {
  const [state, dispatch] = React.useReducer(reducer, defaultState);
  const theme = useTheme();

  const handleSubmit = e => {
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", ...state })
    })
      .then(() => alert("Success!"))
      .catch(error => alert(error));

    e.preventDefault();
  };

  const handleEmail = React.useCallback(
    e => dispatch({ type: "EMAIL", payload: e.target.value }),
    []
  );
  const handleMessage = React.useCallback(
    e => dispatch({ type: "MESSAGE", payload: e.target.value }),
    []
  );

  return (
    <FormStyled onSubmit={handleSubmit} netlify theme={theme}>
      <input type="hidden" name="form-name" value="contact" />
      <h2>Lasati-ne un mesaj</h2>
      <input
        placeholder="Emailul dumneavoastra..."
        value={state.email}
        onChange={handleEmail}
        name="email"
      />
      <textarea
        placeholder="Ideile si propunerile dumneavoastra..."
        value={state.message}
        onChange={handleMessage}
        name="message"
      />
      <p>Mesajul va fi transmis automat, iar noi va vom contacta ulterior.</p>
      <div>
        <div />
        <ContactUsButton
          background={theme.secondDark}
          textColor={theme.mainDark}
          type="submit"
        >
          Transmiteti
        </ContactUsButton>
        <ExitButton type="button" className="exit" onClick={props.close}>
          Anulati
        </ExitButton>
      </div>
    </FormStyled>
  );
}

const FormStyled = styled.form`
  background-color: #fefefe;
  margin: 10% auto; /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  width: 50%; /* Could be more or less, depending on screen size */
  z-index: 30;
  border-radius: 10px;

  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Helvetica Neue", sans-serif;

  @media (max-width: 500px) {
    width: 90%;
  }

  h2 {
    font-size: 30px;
    margin-bottom: 25px;
    color: ${props => props.theme.secondDark};
    display: inline-block;
    padding-bottom: 8px;
    border-bottom: 3px solid ${props => props.theme.secondDark};
  }

  input {
    width: 60%;
    padding: 15px;
    font-size: 15px;
    outline: none;
    border-radius: 10px;
    border: 2px solid ${props => props.theme.mainDark};
    margin-bottom: 25px;
    color: ${props => props.theme.mainDark};

    @media (max-width: 500px) {
      width: 80%;
    }

    &::placeholder {
      opacity: 0.5;
      color: ${props => props.theme.secondDark};
    }
  }

  textarea {
    width: 60%;
    height: 200px;
    padding: 15px;
    font-size: 15px;
    border: 2px solid ${props => props.theme.mainDark};
    border-radius: 10px;
    outline: none;
    margin-bottom: 15px;
    color: ${props => props.theme.mainDark};

    @media (max-width: 500px) {
      width: 80%;
    }

    &::placeholder {
      opacity: 0.5;
      color: ${props => props.theme.secondDark};
    }
  }

  p {
    font-size: 12px;
    margin-bottom: 25px;
    color: ${props => props.theme.mainDark};

    @media (max-width: 500px) {
      width: 80%;
      text-align: center;
    }
  }

  div {
    display: flex;
    justify-content: space-between;
    width: 100%;

    @media (max-width: 500px) {
      flex-direction: column;
    }

    div {
      width: 10%;
      @media (max-width: 500px) {
        display: none;
      }
    }
  }
`;

const ExitButton = styled.button`
  width: 10%;
  color: #fff;
  padding: 10px;
  font-size: 15px;

  border: 2px solid #fff;
  border-radius: 5px;
  background: red;

  cursor: pointer;
  outline: none;

  @media (max-width: 500px) {
    width: 70%;
    margin: 30px auto 10px;
  }
`;

export default Form;
